import React, { memo } from 'react';
import {
  defaultGeneralData,
  lineHeightStyle,
  styledComponent,
} from '../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const GeneralExaminationView = ({
  prescriptionItems,
  selectedOnExamination,
  setSelectedOnExamination,
  isHistoryPage,
}) => {
  let { generalExaminations } = selectedOnExamination;
  console.log('generalExaminations........', generalExaminations);

  const removeItemsData = (fieldName) => {
    const resetFields = defaultGeneralData();
    if (fieldName in resetFields) {
      const resetValue = resetFields[fieldName];
      if (typeof resetValue === 'object') {
        generalExaminations[fieldName] = { ...resetValue };
      } else {
        generalExaminations[fieldName] = resetValue;
      }
    }
    setSelectedOnExamination({
      ...selectedOnExamination,
      generalExaminations: { ...generalExaminations },
    });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['on-examination']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
  );

  const flexRow = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

  return (
    <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
      {generalExaminations['bloodGroup'] && (
        <li>
          <Title>Blood Group:</Title>{' '}
          <Value>{generalExaminations['bloodGroup']}</Value>
        </li>
      )}
      {(generalExaminations?.bloodPressure?.systolic ||
        generalExaminations?.bloodPressure?.diastolic) && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>BP:</Title>{' '}
            <Value>
              {generalExaminations?.bloodPressure?.systolic}/
              {generalExaminations?.bloodPressure?.diastolic} mmHg
            </Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'bloodPressure'}
            />
          )}
        </li>
      )}
      {(generalExaminations['pulseInfo']['pulse'] ||
        generalExaminations['pulseInfo']['pulseType'] ||
        generalExaminations['pulseInfo']['note']) && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>Pulse:</Title>{' '}
            <Value>
              {generalExaminations?.pulseInfo?.pulse &&
                `${generalExaminations.pulseInfo.pulse} ${
                  generalExaminations.pulseInfo.pulseUnit === 'PM' ? 'PM' : 'BPM'
                }`}
              {generalExaminations['pulseInfo']['pulseType'] && (
                <span> ({generalExaminations['pulseInfo']['pulseType']})</span>
              )}
              {generalExaminations['pulseInfo']['note'] && (
                <span> - {generalExaminations['pulseInfo']['note']}</span>
              )}
            </Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'pulseInfo'}
            />
          )}
        </li>
      )}
      {generalExaminations?.respiratoryRate && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>Respiratory Rate (RR):</Title>{' '}
            <Value>
              <span>{generalExaminations?.respiratoryRate} </span>
            </Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'respiratoryRate'}
            />
          )}
        </li>
      )}
      {generalExaminations['temperatureInfo']['temperature'] && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>Temperature:</Title>{' '}
            <Value>
              {generalExaminations['temperatureInfo'].temperature + ' '}
              {generalExaminations['temperatureInfo']?.temperatureUnit}{' '}
              {generalExaminations['temperatureInfo']['temperatureType'] && (
                <span>
                  ({generalExaminations['temperatureInfo']['temperatureType']})
                </span>
              )}
            </Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'temperatureInfo'}
            />
          )}
        </li>
      )}
      {!generalExaminations['temperatureInfo']['temperature'] &&
        generalExaminations['temperatureInfo'].temperatureType && (
          <li className="text-left" style={flexRow}>
            <span>
              <Title>Temperature:</Title>{' '}
              <Value>
                {generalExaminations['temperatureInfo'].temperatureType && (
                  <span>
                    {generalExaminations['temperatureInfo'].temperatureType}
                  </span>
                )}
              </Value>
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'temperatureInfo'}
              />
            )}
          </li>
        )}
      {generalExaminations['weightInfo']['weight'] &&
        !generalExaminations['weightInfo']['hideWeight'] && (
          <li className="text-left" style={flexRow}>
            <span>
              <Title>Weight:</Title>{' '}
              <Value>
                {generalExaminations['weightInfo'].weight + ' '}
                {generalExaminations['weightInfo'].weightUnit}
              </Value>
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'weightInfo'}
              />
            )}
          </li>
        )}
      {generalExaminations.bsa && generalExaminations.showBsa && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>BSA:</Title> <Value>{generalExaminations?.bsa}</Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn action={removeItemsData} itemName={'bsa'} />
          )}
        </li>
      )}
      {(generalExaminations['heightInfo']['feet'] ||
        generalExaminations['heightInfo']['inch']) &&
        !generalExaminations['heightInfo']['hideHeight'] && (
          <li className="text-left" style={flexRow}>
            <span>
              <Title>Height:</Title>{' '}
              <Value>
                {generalExaminations['heightInfo'].feet + '.'}
                {generalExaminations['heightInfo'].inch
                  ? ' ' + generalExaminations['heightInfo'].inch
                  : 0}
                {' ' + generalExaminations['heightInfo'].heightUnit}
              </Value>
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'heightInfo'}
              />
            )}
          </li>
        )}
      {generalExaminations.bmi && generalExaminations.showBmi && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>BMI:</Title> <Value>{generalExaminations?.bmi}</Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn action={removeItemsData} itemName={'bmi'} />
          )}
        </li>
      )}
      {generalExaminations?.idealWeightInfo?.idealWeight && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>Ideal Weight:</Title>{' '}
            <Value>
              {generalExaminations?.idealWeightInfo?.idealWeight + ' '}
              {generalExaminations?.idealWeightInfo?.idealWeightUnit}
            </Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'idealWeightInfo'}
            />
          )}
        </li>
      )}
      {generalExaminations['idealBmi'] && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>Ideal BMI:</Title>{' '}
            <Value>{generalExaminations['idealBmi']}</Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'idealBmi'}
            />
          )}
        </li>
      )}
      {generalExaminations['targetDailyCalory'] && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>Target Daily Calory:</Title>{' '}
            <Value>{generalExaminations['targetDailyCalory']}</Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'targetDailyCalory'}
            />
          )}
        </li>
      )}
      {generalExaminations.diabetes && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>Diabetes:</Title>{' '}
            <Value>{generalExaminations?.diabetes}</Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'diabetes'}
            />
          )}
        </li>
      )}
      {generalExaminations?.anaemia?.status && (
        <li className="text-left">
          <div style={flexRow}>
            <span>
              <Title>Anaemia:</Title>{' '}
              <Value>{generalExaminations?.anaemia?.status}</Value>
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'anaemia'}
              />
            )}
          </div>
          {generalExaminations?.anaemia?.note && (
            <span>
              {' '}
              - <Value>{generalExaminations?.anaemia?.note}</Value>
            </span>
          )}
        </li>
      )}
      {generalExaminations?.jaundice?.status && (
        <li className="text-left">
          <div style={flexRow}>
            <span>
              <Title>Jaundice:</Title>{' '}
              <Value>{generalExaminations?.jaundice?.status}</Value>
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'jaundice'}
              />
            )}
          </div>
          {generalExaminations?.jaundice?.note && (
            <span>
              {' '}
              - <Value>{generalExaminations?.jaundice?.note}</Value>
            </span>
          )}
        </li>
      )}
      {generalExaminations?.cyanosis?.status && (
        <li className="text-left">
          <div style={flexRow}>
            <span>
              <Title>Cyanosis:</Title>{' '}
              <Value>{generalExaminations?.cyanosis?.status}</Value>
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'cyanosis'}
              />
            )}
          </div>
          {generalExaminations?.cyanosis?.note && (
            <span>
              {' '}
              - <Value>{generalExaminations?.cyanosis?.note}</Value>
            </span>
          )}
        </li>
      )}
      {generalExaminations?.clubbing?.status && (
        <li className="text-left">
          <div style={flexRow}>
            <span>
              <Title>Clubbing:</Title>{' '}
              <Value>{generalExaminations?.clubbing?.status}</Value>
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'clubbing'}
              />
            )}
          </div>
          {generalExaminations?.clubbing?.note && (
            <span>
              {' '}
              - <Value>{generalExaminations?.clubbing?.note}</Value>
            </span>
          )}
        </li>
      )}
      {generalExaminations?.spo2 && (
        <li className="text-left" style={flexRow}>
          <span>
            <Title>SpO2:</Title> <Value>{generalExaminations?.spo2} %</Value>
          </span>
          {!isHistoryPage && (
            <ChiefComplainDeleteBtn
              action={removeItemsData}
              itemName={'spo2'}
            />
          )}
        </li>
      )}
      {generalExaminations?.edemaInfo?.value && (
        <li className="text-left">
          <div style={flexRow}>
            <span>
              <Title>Edema:</Title>{' '}
              <Value>{generalExaminations?.edemaInfo?.value}</Value>
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'edema'}
              />
            )}
          </div>
          {generalExaminations?.edemaInfo?.note && (
            <span>
              {' '}
              - <Value>{generalExaminations?.edemaInfo?.note}</Value>
            </span>
          )}
        </li>
      )}
    </ul>
  );
};

export default memo(GeneralExaminationView);
